import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const sinManual = ['Buscás en 3 libros mientras el reloj corre', 'Dudás del cálculo de goteo y la dilución', 'No sabés qué hacer hasta que llegue el médico', 'Registros incompletos que te exponen', 'Terminás cada turno agotada y con miedo'];
const conManual = ['La respuesta correcta en segundos', 'Fórmulas y diluciones resueltas', 'Sabés qué resolver vos y qué derivar', 'Planillas que te cubren legalmente', 'Terminás el turno con seguridad'];
export function SinVsCon() {
  return <section className="py-12 bg-white px-4" data-id="element-209">
      <div className="max-w-4xl mx-auto" data-id="element-210">
        <div className="text-center mb-8" data-id="element-211">
          <h2 className="text-2xl md:text-3xl font-bold text-navy-900 mb-2" data-id="element-212">
            La diferencia entre sobrevivir y destacar
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-5" data-id="element-213">
          {/* SIN */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 border border-red-200 rounded-2xl p-4 md:p-6" data-id="element-214">
            <h3 className="text-base md:text-lg font-bold text-red-900 mb-4 flex items-center gap-2" data-id="element-215">
              <span className="bg-red-200 text-red-700 p-1 rounded-md" data-id="element-216">
                <X size={16} data-id="element-217" />
              </span>
              Sin el Manual
            </h3>
            <ul className="space-y-2.5" data-id="element-218">
              {sinManual.map((item, i) => <li key={i} className="flex items-start gap-2 text-red-800/80" data-id="element-219">
                  <X size={14} className="shrink-0 mt-1 text-red-400" data-id="element-220" />
                  <span className="text-xs md:text-sm leading-snug" data-id="element-221">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* CON */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-pastel-50 border-2 border-navy-800 rounded-2xl p-4 md:p-6 shadow-lg" data-id="element-222">
            <h3 className="text-base md:text-lg font-bold text-navy-900 mb-4 flex items-center gap-2" data-id="element-223">
              <span className="bg-navy-800 text-white p-1 rounded-md" data-id="element-224">
                <Check size={16} data-id="element-225" />
              </span>
              Con el Manual
            </h3>
            <ul className="space-y-2.5" data-id="element-226">
              {conManual.map((item, i) => <li key={i} className="flex items-start gap-2 text-navy-800" data-id="element-227">
                  <Check size={14} className="shrink-0 mt-1 text-navy-800 font-bold" data-id="element-228" />
                  <span className="text-xs md:text-sm leading-snug font-medium" data-id="element-229">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}